import React from 'react';
import classnames from 'classnames';

class SelectOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: undefined
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({
      value: e.target.value
    });
  }

  render() {
      let props = this.props;
      let nodes = this.props.items.map((items, index) => {

      return (
      <option key={index}
        value={items.value}
        hidden={items.hidden}
      >
        {items.label}
      </option>
    );
    });

    return (

      <div className={classnames('control', {'simple-radio-input': this.props.simpleRadio}, {'simple-select': this.props.simpleSelect})}>
        {
          props.controlLabel
          ? <label>{props.controlLabel}</label>
          : null
        }
        {
          this.props.labelSubtext
          ? <p className="label-subtext">{this.props.labelSubtext}</p>
          : null
        }
        <select className="simple-select" value={this.state.value} onChange={props.handleChange} onBlur={this.props.onBlur}>
          {nodes}
        </select>
        {
          this.props.simpleSelectSubtext
          ? <p className="simple-select__subtext">{this.props.simpleSelectSubtext}</p>
          : null
        }
      </div>
      );
  }
}

SelectOptions.defaultProps = {
    items: [
      {value: 30, label: "30 days"},
      {value: 60, label: "60 days"},
      {value: 90, label: "90 days"}
    ],
    onChange: function(){},
    labelText: '',
    labelSubtext: '',
    simpleSelectSubtext: '',
    name: ''
};

SelectOptions.propTypes={
  items: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
  name: React.PropTypes.string.isRequired,
  onBlur: React.PropTypes.func,
  onChange: React.PropTypes.func.isRequired,
  labelText: React.PropTypes.string.isRequired,
  labelSubtext: React.PropTypes.string.isRequired,
  simpleSelectSubtext: React.PropTypes.string.isRequired,
  simpleRadio: React.PropTypes.string,
  simpleSelect: React.PropTypes.bool
};

export default SelectOptions;



// WEBPACK FOOTER //
// ./src/components/forms/SelectOptions.js